export default __webpack_public_path__ + "static/media/porshia-profile.99e2e32d.jpg";